export default (node) => {
  /**
   * Data + elements
   */
  const allTitles = node.querySelectorAll('[data-menu-main-title]');
  const allMegaMenus = node.querySelectorAll('[data-mega-menu]');
  const menuOverlay = document.querySelector('[data-desktop-menu-overlay]');
  /**
   * Functions
   */
  const openMegaMenu = (mainTitle) => {
    menuOverlay.classList.remove('hidden');
    allMegaMenus.forEach((oneMegaMenu) => {
      if (oneMegaMenu.getAttribute('data-mega-menu') === mainTitle) {
        oneMegaMenu.classList.remove('hidden');
      } else {
        oneMegaMenu.classList.add('hidden');
      }
    });
  };

  const closeMegaMenu = () => {
    allMegaMenus.forEach((oneMegaMenu) => {
      oneMegaMenu.classList.add('hidden');
    });
    menuOverlay.classList.add('hidden');
    // dispatch event to close the mega menu
    document.dispatchEvent(new CustomEvent('desktop-menu-mega:close'));
  };
  /**
   * Init
   */
  const init = () => {
    allTitles.forEach((oneTitle) => {
      oneTitle.addEventListener('mouseenter', (e) => {
        const element = e.currentTarget;
        openMegaMenu(element.getAttribute('data-menu-main-title'));
      });
    });
    menuOverlay.addEventListener('mouseenter', closeMegaMenu);

    document.addEventListener('desktop-menu:close', closeMegaMenu);
  };

  init();
};
